import {
  ComponentProps,
  createContext,
  FC,
  ReactElement,
  useContext,
  useMemo,
  useState,
} from 'react';

interface BannerContextInterface {
  bannerDetails: any;
  setBannerDetails: (details: any) => void;
  // bannerRefreshTrigger: boolean;
  // triggerBannerRefresh: () => void;
}

const BannerDetailsContext = createContext<BannerContextInterface>({
  bannerDetails: null,
  setBannerDetails: () => {},
  // bannerRefreshTrigger: false,
  // triggerBannerRefresh: () => {},
});

export const useBannerDetails = (): BannerContextInterface => useContext(BannerDetailsContext);

const BannerDetailsProvider = ({
  children,
}: ComponentProps<FC<any>> & { children: ReactElement }): JSX.Element => {
  const [bannerDetails, setBannerDetails] = useState<any>(null);
  // const [bannerRefreshTrigger, setBannerRefreshTrigger] = useState(false);

  // const triggerBannerRefresh = () => {
  //   setBannerRefreshTrigger((prev) => !prev); // toggle the trigger
  // };

  const contextValue = useMemo(
    () => ({
      bannerDetails,
      setBannerDetails,
      // bannerRefreshTrigger,
      // triggerBannerRefresh
    }),
    [
      bannerDetails,
      // bannerRefreshTrigger
    ]
  );

  return (
    <BannerDetailsContext.Provider value={contextValue}>{children}</BannerDetailsContext.Provider>
  );
};

export default BannerDetailsProvider;
